/*eslint @typescript-eslint/no-unused-vars: "off"*/
/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @interface FormDefinitionEntityError
 */
export interface FormDefinitionEntityError {
    /**
     * 
     * @type {string}
     * @memberof FormDefinitionEntityError
     */
    code: FormDefinitionEntityErrorCodeEnum;
}




/**
* @export
* @enum {string}
*/
export enum FormDefinitionEntityErrorCodeEnum {
    NOVALIDQUESTION = 'NO_VALID_QUESTION'
}


